import React, { Fragment } from 'react'
import { css, StyleSheet } from 'aphrodite'
import Tooltip from '@material-ui/core/Tooltip'
import { SingleSelectDropDown } from '../../common/components/SingleSelectDropDown'

import { Helper } from '../../common/helpers/Helper'
import { BaseEntityPage } from '../../common/components/BaseEntityPage'
import { AppStyles } from '../../styles/AppTheme'
import { DisplayPreviewDialog } from '../../components/DisplayPreviewDialog'
import { AppUiHelper } from '../../helpers/AppUiHelper'
import { DisplayWeblinkPreviewDialog } from '../../components/DisplayWeblinkPreviewDialog'
import { UiHelper } from '../../common/helpers/UiHelper'
import moment from 'moment'

export class DaypartingSchedule extends BaseEntityPage {

  exportConfig = {
    headers: {
      displayTime: 'Start Time',
      content: 'Media',
      mediaType: 'Media Type',
      durationSecs: 'Duration',
    },
    format: 'xlsx'
  }

  constructor(props) {
    super(props)
    this.noAdd = true
    this.pageKey = 'DaypartingSchedule'
    this.pageTitle = 'Dayparting Schedule'
    this.noTableHead = true
    this.orgId = 'PRODUCT'

    this.deviceId = this.props.match.params.id
    this.toFetch = [
      {
        method: 'GET',
        paths: ['miscs', 'dayparting'],
        queryParams: {
          deviceId: this.deviceId
        }
      },
      {
        method: 'GET',
        paths: ['devices', this.deviceId],
        queryParams: {
          orgId: 'PRODUCT',
          pb: 'fieldDef'
        }
      }
    ]
    console.log('this.baseRoute()',this.baseRoute())
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: Helper.getString('venues'), to: this.baseRoute() + '/screens'},
      { title: this.pageTitle  }
    ]

    this.tableHeadersMap = {
      'Start Time': (current) => (
        <span className={css(Styles.startTime)}>
          {current && current.customLastRow ? '' : '+ '}
          {current.displayTime}
        </span>
      ),

      Content: (current) => {
        if (current && current.customLastRow) {
          return <span className={css(Styles.duration)}>{current.content}</span>
        } else if (current.mediaType === 'VIDEO') {
          return AppUiHelper.renderVideoThumbnailCustomStyle(current, {}, { _IMAGEFIT: true, _LARGEIMAGE: true, _BORDER:true  })
        } else if (current.mediaType === 'WEBLINK') {
          return <i className={'material-icons-outlined ' + css(Styles.icons)}>http</i>
        } else if (current.mediaType === 'TEXT') {
          return (
            <i
              alt={Helper.getString('assetTextAlt')}
              className={'material-icons-outlined ' + css(Styles.icons)}
            >
              text_snippet
            </i>
          )
        } else {
          return AppUiHelper.itemImage({
            ...current,
            _IMAGEFIT: true,
            _LARGEIMAGE: true,
            _BORDER:true,
            image: current.mediaType === 'IMAGE' || current.mediaType === 'QRWEBLINK'
              ? current.content
              : undefined
          })
        }
      },

      Duration: (current) => (
        <span className={css(Styles.duration)}>
          <div>{current.durationSecs ? `${parseFloat(current.durationSecs).toFixed(2)} Secs` : ''}</div>
          <div>{current.mediaType ? `${current.mediaType}` : ''}</div>
        </span>
      ),
    }

    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.headerActions = [
      {
        label: 'Download',
        onClick: () => this.onExport()
      }
    ]

    this.emptyText = 'No dayparting schedule found'
    this.state = {
      ...this.state,
      items: [],
      itemsByPlacement: {},
      selectedPlacement: 'DEFAULT',
      preview: false,
      current: null
    }
  }

  addProgrammaticFallbackRow = (items, placement) => {
    if (!items.length) return items

    const lastItem = items[items.length - 1]
    const [minutes, seconds] = (lastItem.displayTime || '00:00').split(':').map(Number)
    const lastItemStartSecs = (minutes * 60) + seconds
    // Dayparting rows begin one second after the preceding item's duration ends.
    const fallbackStartSecs = lastItemStartSecs + (Number(lastItem.durationSecs) || 0)
    const cycleDurationSecs = 15 * 60

    if (fallbackStartSecs >= cycleDurationSecs) return items

    const fallbackStartTime = lastItem.endTime ? lastItem.endTime : undefined
    // Fill only the remaining time in the 15-minute dayparting cycle.
    const fallbackDurationSecs = cycleDurationSecs - fallbackStartSecs

    return [
      ...items,
      {
        customLastRow:true,
        content: Helper.getString(placement === 'DEFAULT' ? 'programmaticAdsMayRepeat' : 'cmsAdsWillRepeat'),
        // durationSecs: fallbackDurationSecs,
        mediaType: '',
        displayTime: `From ${String(Math.floor(fallbackStartSecs / 60)).padStart(2, '0')}:${String(Math.floor(fallbackStartSecs % 60)).padStart(2, '0')} - 15:00`,
        startTime: fallbackStartTime,
        endTime: fallbackStartTime ? fallbackStartTime + (fallbackDurationSecs * 1000) : undefined,
        startTimeStr: fallbackStartTime ? moment(fallbackStartTime).format('hh:mm:ss a') : undefined,
        endTimeStr: fallbackStartTime ? moment(fallbackStartTime + (fallbackDurationSecs * 1000)).format('hh:mm:ss a') : undefined,
        __index: items.length
      }
    ]
  }

  onFetchSuccess(results) {
    const result = results && results[0]
    const device = results && results[1]

    const itemsByPlacement = (result && result.itemsByPlacementLabel) || {}
    const placementLabels = Object.keys(itemsByPlacement)
    const selectedPlacement = placementLabels.includes('DEFAULT') ? 'DEFAULT' : placementLabels[0] || 'DEFAULT'

    this.pageTitle = `Dayparting Schedule (${device && device.deviceCode || ''})`

    this.setState({
      itemsByPlacement,
      selectedPlacement,
      items: this.addProgrammaticFallbackRow(itemsByPlacement[selectedPlacement] || [], selectedPlacement)
    })
  }

  onPlacementChange = (event) => {
    const selectedPlacement = event.target.value
    this.setState({
      selectedPlacement,
      items: this.addProgrammaticFallbackRow(this.state.itemsByPlacement[selectedPlacement] || [], selectedPlacement),
      preview: false,
      current: null
    })
  }

  onExport = () => {
    if (!this.exportConfig || Object.keys(this.exportConfig.headers).length === 0) {
      return
    }

    const DwnldUtil = require('../../common/helpers/FileDownloader')

    const rows = this.state.items.map((current) => ({
      'Start Time': current.displayTime,
      Media: current.content,
      'Media Type': current.mediaType,
      Duration: parseFloat(current.durationSecs).toFixed(2)
    }))

    DwnldUtil.FileDownloader.exportAsExcelFile(
      rows,
      `dayparting-schedule-${this.deviceId}_` + moment().format('MM-DD-YYYY_HH-mm-ss')
    )
  }

  onActions(current) {
    const actions = []
    if (
      current.mediaType === 'IMAGE' ||
      current.mediaType === 'QRWEBLINK' ||
      current.mediaType === 'VIDEO' ||
      current.mediaType === 'WEBLINK'
    ) {
      UiHelper.addActionButtonByRole(actions, this.previewButton(current), [])
    }
    return actions
  }

  previewButton(current) {
    return (
      <Tooltip title='Preview' placement='top-start' key={current.id + 'Preview'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img
            className={css(Styles.actionIconImage)}
            src={require('../../assets/icons/eye.svg')}
            onClick={() => {
              this.setState({ preview: true, current })
            }}
          />
        </span>
      </Tooltip>
    )
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''

    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  renderAboveTable() {
    const placementLabels = Object.keys(this.state.itemsByPlacement)
    const showPlacementDropdown = !(placementLabels.length === 1 && placementLabels[0] === 'DEFAULT')

    return (
      <div className={css(Styles.aboveTable)}>
        {showPlacementDropdown && <div className={css(Styles.placementFilter)}>
          <SingleSelectDropDown
            onSinglePickerFilter={this.onPlacementChange}
            disabled={Object.keys(this.state.itemsByPlacement).length === 0}
            inputContainer={Styles.placementDropdown}
            singleSelectPicker={{
              // title: 'Placement',
              defaultValue: this.state.selectedPlacement,
              options: (Object.keys(this.state.itemsByPlacement).length
                ? Object.keys(this.state.itemsByPlacement)
                : ['DEFAULT'])
                .sort((a, b) => {
                  if (a === b) return 0;
                  if (a === 'DEFAULT') return -1;
                  if (b === 'DEFAULT') return 1;
                  return a.localeCompare(b);
                })
                .map((label) => ({ key: label, value: label }))
            }}
          />
        </div>}

        <div className={css(Styles.description)}>
          <span>The schedule repeats every 15min boundary of an hour. (eg: 1:15pm, 1:30pm, 1:45pm etc)</span>
          <span>Times below are offsets within each cycle in MM:SS.</span>
        </div>

        {this.state.error &&
          <div className={css(Styles.error)}>
            {this.state.error}
          </div>
        }

        {this.renderPreviewDialogs()}
      </div>
    )
  }

  renderPreviewDialogs() {
    if (!this.state.preview || !this.state.current) return ''

    if (
      this.state.current.mediaType === 'IMAGE' ||
      this.state.current.mediaType === 'QRWEBLINK' ||
      this.state.current.mediaType === 'VIDEO'
    ) {
      return (
        <DisplayPreviewDialog
          title={this.state.current.title}
          isOpen={!!this.state.preview}
          adLink={this.state.current.content}
          onClosed={() => this.setState({ preview: undefined })}
        />
      )
    } else if (this.state.current.mediaType === 'WEBLINK') {
      return (
        <DisplayWeblinkPreviewDialog
          title={this.state.current.title}
          isOpen={!!this.state.preview}
          adLink={this.state.current.content}
          onClosed={() => this.setState({ preview: undefined })}
        />
      )
    }
  }
}

const Styles = StyleSheet.create({
  aboveTable: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  placementDropdown: {
    maxWidth: '100%'
  },
  placementFilter: {
    width: 320,
    maxWidth: '100%',
    alignSelf: 'flex-end',
    marginBottom: 16
  },
  description: {
    width: '100%',
    // marginBottom: 20,
    padding: '12px 16px',
    backgroundColor: '#eef8ff',
    border: '1px solid #b8e2f7',
    // borderLeft: '4px solid #2496c9',
    borderRadius: 6,
    color: '#185a7a',
    fontSize: 14,
    lineHeight: 1.5,
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    boxSizing: 'border-box'
  },

  error: {
    marginBottom: 20
  },

  duration: {
    fontSize: 16
  },

  startTime: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#2029f1',
  },

  icons: {
    fontSize: 30,
    color: '#fff',
    marginRight: 12,
    background: 'rgb(228, 228, 228)',
    borderRadius: 8,
    width: 80,
    height: 80,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
})



// WEBPACK FOOTER //
// ./src/screens/admin/DaypartingSchedule.js